
import { ERROR_CODES } from './constants';

/**
 * Custom error class for storage operations
 */
export class StorageError extends Error {
  code: string;
  details?: Record<string, any>;

  constructor(message: string, code: string, details?: Record<string, any>) {
    super(message);
    this.name = 'StorageError';
    this.code = code;
    this.details = details;
  }
}

/**
 * Create a file size error
 */
export function createFileSizeError(fileSize: number, maxSize: number): StorageError {
  return new StorageError(
    `File size exceeds the maximum allowed size of ${maxSize / (1024 * 1024)}MB`,
    ERROR_CODES.FILE_TOO_LARGE,
    { fileSize, maxSize }
  );
}

/**
 * Create a file type error
 */
export function createFileTypeError(mimeType: string, allowedTypes: string[]): StorageError {
  return new StorageError(
    `File type ${mimeType} is not allowed. Allowed types: ${allowedTypes.join(', ')}`,
    ERROR_CODES.INVALID_TYPE,
    { mimeType, allowedTypes }
  );
}

/**
 * Create an upload error
 */
export function createUploadError(message: string, details?: any): StorageError {
  return new StorageError(
    `Upload failed: ${message}`,
    ERROR_CODES.UPLOAD_FAILED,
    details
  );
}

/**
 * Create a delete error
 */
export function createDeleteError(message: string, details?: any): StorageError {
  return new StorageError(
    `Delete failed: ${message}`,
    ERROR_CODES.DELETE_FAILED,
    details
  );
}
